import { EChartService } from '@/service/echart/echart.service';
import { Big5Score } from '@/models/student/student-karte';
import { NumberUtils } from '@/utils/number.utils';

export class Big5EchartService extends EChartService {
  big5Scores: Big5Score[] = [];

  constructor() {
    super();
  }

  /**
   * AIGROW2-184 箱ひげ図にデータテーブルを追加
   * 箱ひげ図のみにデータを表形式で表示する
   * EChartService が箱ひげ図以外のグラフでも共通なので、空配列を返すだけのものを追加しています
   * subTableColmuns
   * subTableData
   */
  get subTableColmuns(): any[] {
    return [];
  }
  get subTableData(): any[] {
    return [];
  }

  setBig5Scores(big5Scores: Big5Score[]) {
    this.big5Scores = big5Scores;
  }

  get emphasisLabel(): any {
    return {
      fontWeight: 'bold',
      borderWidth: 2,
      borderRadius: 1,
      padding: 3,
    };
  }

  get lowScoreTitles(): any[] {
    return this.big5Scores
      .map((d: Big5Score) => {
        const emphasisStyle = d.scoreInt < 0 ? this.emphasisLabel : {};
        return {
          value: d.lowScoreTitle,
          textStyle: {
            color: d.color,
            borderColor: d.color,
            fontSize: 20,
            ...emphasisStyle,
          },
        };
      })
      .reverse();
  }

  get highScoreTitles(): any[] {
    return this.big5Scores
      .map((d: Big5Score) => {
        const emphasisStyle = d.scoreInt > 0 ? this.emphasisLabel : {};
        return {
          value: d.highScoreTitle,
          textStyle: {
            color: d.color,
            borderColor: d.color,
            fontSize: 20,
            ...emphasisStyle,
          },
        };
      })
      .reverse();
  }

  get hasOverflowData(): boolean {
    return this.big5Scores.filter(d => d.score >= 2 || d.score <= -2).length > 0;
  }

  addSeries(): void {}

  get options() {
    let gridOptions = { width: '50%', containLabel: true, left: '25%', right: '25%' };

    return {
      tooltip: { show: false, trigger: 'axis', axisPointer: { type: 'shadow' } },
      grid: {
        top: 0,
        bottom: 0,
        show: true,
        width: `${gridOptions.width}%`,
        height: '99%',
        left: `${gridOptions.left}%`,
        right: `${gridOptions.right}%`,
      },
      xAxis: [
        {
          type: 'value',
          position: 'top',
          splitLine: { lineStyle: { type: 'dashed' } },
          min: this.hasOverflowData ? -2.5 : -2,
          max: this.hasOverflowData ? 2.5 : 2,
          axisLabel: { color: 'rgba(0,0,0,0.0)' },
        },
        {
          type: 'value',
          position: 'bottom',
          splitLine: { lineStyle: { type: 'dashed' } },
          min: this.hasOverflowData ? -2.5 : -2,
          max: this.hasOverflowData ? 2.5 : 2,
          axisLabel: { color: 'rgba(0,0,0,0.0)' },
        },
      ],
      yAxis: [
        {
          type: 'category',
          // nameGap: 0,
          axisTick: { show: false },
          axisLabel: { height: '11px', margin: 20 },
          data: this.lowScoreTitles,
        },
        {
          type: 'category',
          // nameGap: 0,
          axisTick: { show: false },
          axisLabel: { height: '11px', margin: 20 },
          data: this.highScoreTitles,
        },
      ],
      series: [
        {
          name: 'category',
          type: 'bar',
          barWidth: 40,
          label: {
            normal: {
              show: true,
              position: 'inside',
              align: 'center',
              fontSize: 20,
              formatter: function (d: any) {
                return Math.abs(NumberUtils.plusFloorAndMinusCeil(d.value * 50));
              },
            },
          },
          // itemStyle: { normal: { color: this.barColor } },
          data: this.big5Scores
            .map((d: Big5Score) => {
              return { value: d.score, itemStyle: { normal: { color: d.color } } };
            })
            .reverse(),
        },
      ],
    };
  }
}
